// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"263":"7bb8400f","513":"fee05618","703":"fed52f3b","787":"073a0d46","936":"ece1b41e"}[chunkId] + ".chunk.js";
};